import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function ProofOfConcept() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Proof of Concept
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Proof of Concept
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Proof-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Protein production
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Proof-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Guanine assay
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Proof-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Theories of the possible guanine concentration
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Proof-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Protein production
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                We were able to successfully clone and express GuaA and GuaB according to their
                                visualisation in the SDS page gel. However, we have no proof supporting that their
                                function is being performed for that reason we performed a guanine assay to assess
                                if the concentration of guanine increased.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Proof-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Guanine assay
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                We used two colorimetric and one fluorometric guanine assay kit from Cell BioLabs,
                                however, neither of them gave us results as the standard values obtained from the
                                plate reader did not represent the technical respective concentrations (the three
                                times the assay was performed). So, we cannot assure that the guanine concentration
                                is increasing in the cell as the only commercially available kit does not work.
                            </div>
                            <div className="mt-5">
                                Even if the standard measurements were accurate, the above-mentioned kit is designed
                                for measuring guanine concentration in biological samples, such as serum, urine and
                                mammalian cell lysates, so it is possible that the results regarding the samples are
                                not correct due to their bacterial nature.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Proof-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Theories of the possible guanine concentration
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-5 rounded-2xl leading-relaxed">
                            <div>
                                Nevertheless we have different theories about the guanine concentration in the
                                transformed cultures. It is possible that the concentration of guanine has increased
                                without reaching the critical concentration necessary for nucleation and posterior
                                crystallisation. Another possibility is that GuaA and GuaB are working as expected
                                but the guanine synthesis is strictly regulated in the cell and the degradation
                                enzymes are being overexpressed thus the concentration of guanine would not change
                                with respect to the uninduced or only backbone control. If this was the case, a
                                knockdown of the genes that code for the degrading enzyme would be necessary for
                                the crystal formation.
                            </div>
                        </div>
                    </div>



                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}